import { render, staticRenderFns } from "./LmEmailTemplatesListbuilder.vue?vue&type=template&id=f304e4d2"
import script from "./LmEmailTemplatesListbuilder.vue?vue&type=script&lang=js"
export * from "./LmEmailTemplatesListbuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports